/* eslint-disable no-unused-vars */

export enum LoginFormProvider {
  GOOGLE = "google",
}
